'use strict';

function disableFields(elemClass, state) {
    var elements = $('.' + elemClass);
    var dataRole;

    elements.each(function (i, item){
        dataRole = $(item).attr('data-role');

        switch (dataRole){
            case('datetimepicker'):
                $(item).data('kendoDateTimePicker').enable(!state);
                break;
            case('numerictextbox'):
                $(item).data('kendoNumericTextBox').enable(!state);
                break;
            case('dropdownlist'):
                $(item).data('kendoDropDownList').enable(!state);
                break;
            case('combobox'):
                $(item).data('kendoComboBox').enable(!state);
                break;
            case('datepicker'):
                $(item).data('kendoDatePicker').enable(!state);
                break;
            case('multiselect'):
                $(item).data('kendoMultiSelect').enable(!state);
                break;
            case('button'):
                $(item).data('kendoButton').enable(!state);
                break;
            case('autocomplete'):
                $(item).data('kendoAutoComplete').enable(!state);
                break;
            case(undefined):
                if (state){
                    $(item).attr('disabled', '');
                    $(item).addClass('disabled-textbox');
                } else {
                    $(item).removeAttr('disabled');
                    $(item).removeClass('disabled-textbox');
                }
                break;
        }
    });
}

function findAncestor(element, selector) {
    if (element.closest) {
        return element.closest("li");
    } else {
        function findAncestor(el, sel) {
            while ((el = el.parentElement) && !((el.matches || el.matchesSelector).call(el, sel)));
            return el;
        }
        return findAncestor(element, "li");
    }
}

/*
 * Accepts object {key:value}, returns encoded string ?key=value&key1=value1
 */
function formatQueryStringParams(params) {
    return "?" + Object
        .keys(params)
        .map(function (key) {
            return key + "=" + encodeURIComponent(params[key])
        })
        .join("&")
}

function downloadTextFile (filename, fileType, data) {
    let blob = new Blob([data], { type: fileType });
    if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, filename);
    }
    else {
        var elem = window.document.createElement('a');
        elem.href = window.URL.createObjectURL(blob);
        elem.download = filename;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
}

function copyToClipboard(text) {
    let dummy = document.createElement("textarea");
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand("copy");
    document.body.removeChild(dummy);
}

module.exports = {
    disableFields: disableFields,
    findAncestor: findAncestor,
    formatQueryStringParams: formatQueryStringParams,
    downloadTextFile: downloadTextFile,
    copyToClipboard: copyToClipboard
};